import { Controller } from "@hotwired/stimulus"

// Toolbar button → opens the Scheduled Reports manage modal.
// Mirrors portfolio_alert_launcher_controller.js.
export default class extends Controller {
  open(event) {
    event?.preventDefault()
    document.dispatchEvent(new CustomEvent("portfolio-scheduled-reports-manage:open"))
  }
}
